export enum Illumination {
  ON = 'on',
  OFF = 'off',
  BLINK = 'blink',
}

export type IlluminationMode = Illumination.ON | Illumination.OFF | Illumination.BLINK;
